// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAIyKoKLdrE0HCOhm9h432SHq-XIpXRzQc",
  authDomain: "persona5-8ba93.firebaseapp.com",
  databaseURL: "https://persona5-8ba93-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "persona5-8ba93",
  storageBucket: "persona5-8ba93.firebasestorage.app",
  messagingSenderId: "450565392402",
  appId: "1:450565392402:web:4939b488413e6d2ff4b0cb",
  measurementId: "G-DL4DDLCQBK"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const storage = getStorage(app);